export default "__VITE_ASSET__B3qJYl22__"